import { Link, useLocation } from "react-router-dom";
import { menuItems } from "../../../data/menu";
import useAppHeader from "../../AppHeader/logic/useAppHeader";

export default function Nav() {
  const location = useLocation();
  const pathname = location.pathname;
  const { authenticatedUser } = useAppHeader();

  const isParentActive = (links) => {
    return links.some((elm) => elm.url.split("/")[1] === pathname.split("/")[1]);
  };

  // Filter menuItems based on role or hide for unauthenticated users
  const filteredMenuItems = menuItems.filter((item) => {
    // Hide admin and manager spaces when not authenticated
    if (!authenticatedUser) {
      return !item.roles || (!item.roles.includes('Admin') && !item.roles.includes('DivisionManager')) && !item.roles.includes('Project Manager') && !item.roles.includes('Editor');
    }

    // If authenticated, filter based on user roles
    if (item.roles) {
      return item.roles.some((role) => authenticatedUser.roles.includes(role));
    }

    return true; // Show items without role restrictions
  });

  return (
    <>
      {filteredMenuItems.map((item, index) => (
        <li
          key={index}
          className={`menu-item ${item.hasChildren ? "menu-item-has-children" : ""} 
            ${isParentActive(item.subMenu ? item.subMenu : []) ? "current-menu-item" : ""} 
            ${item.url?.split("/")[1] === pathname.split("/")[1] ? "current-menu-item" : ""}`}
        >
          {item.hasChildren ? (
            <a href={item.url}>{item.text}</a>
          ) : (
            <Link className={`menu-item`} to={item.url}>
              {item.text}
            </Link>
          )}
          {item.subMenu && item.subMenu.length > 0 && (
            <ul className="sub-menu">
              {item.subMenu.map((subItem, subIndex) => (
                <li
                  key={subIndex}
                  className={`menu-item ${subItem.url.split("/")[1] === pathname.split("/")[1]
                    ? "current-item"
                    : ""}`}
                >
                  <Link to={subItem.url}>{subItem.text}</Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </>
  );
}
